@if (!isDeleted) {
  <div
    >
    @switch (field().controlType) {
      @case ('textbox') {
        <material-form-input [title]="field().label"
        [control]="control()" />
      }
      @case ('json-editor') {
        <inspekt-form-schema-editor [title]="field().label"
        [control]="control()" />
      }
      @case ('textarea') {
        <material-form-text-area [title]="field().label"
        [control]="control()" />
      }
      @case ('checkbox') {
        <material-form-check-box [title]="field().label"
          [control]="control()" />
      }
      @case ('keyvaluepair') {
        <div>
          <mat-form-field appearance="outline"
            style="width:40%">
            <mat-label>{{description}}</mat-label>
            <input matInput
              [(ngModel)]="field().value"
              (change)="emitValue()">
            </mat-form-field>
            <mat-form-field appearance="outline"
              style="width:40%">
              <mat-label>{{enum}}</mat-label>
              <input matInput
                [(ngModel)]="field().key"
                (change)="emitValue()">
              </mat-form-field>
              <button mat-icon-button
                (click)="deletePickListOptions(field().key)">
                <mat-icon matTooltip="Delete this option from Picklist"
                matTooltipShowDelay="300">delete</mat-icon>
              </button>
            </div>
          }
        }
      </div>
    }
